import React, { useState, useRef, useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import Breadcrumb from "./Breadcrumb";
import { MdInsertChartOutlined } from "react-icons/md";
import { BiScan } from "react-icons/bi";
import { TbLineScan } from "react-icons/tb";
import { GoArrowUpRight } from "react-icons/go";
import Swal from "sweetalert2";
import { venueManagerBookingUrl } from "../services/adminApiService/venueManagerApi/venueManagerApi";
// import StatsCard from "./comp/statsCards";
// import { statsData } from "./comp/stats";
import PaymentPopup from "./paymentPopUp"
import "./styles.css";

function VenueManagerDashboard() {
  const [bookingId, setBookingId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const isScanHandled = useRef(false);
  const qrScannerRef = useRef(null);
  const [openPaymentPopup, setOpenPaymentPopup] = useState(false);

  const [selectedBookingId, setSelectedBookingId] = useState(null);

  const startScanner = () => setShowScanner(true);

  const stopScanner = () => {
    if (isScanning && qrScannerRef.current) {
      qrScannerRef.current
        .stop()
        .then(() => {
          qrScannerRef.current.clear();
          setShowScanner(false);
          setIsScanning(false);
        })
        .catch((err) => {
          console.warn("Error stopping scanner:", err);
        });
    } else {
      setShowScanner(false);
    }
  };

  useEffect(() => {
    if (showScanner) {
      const html5QrCode = new Html5Qrcode("qr-reader");
      qrScannerRef.current = html5QrCode;
      isScanHandled.current = false;

      html5QrCode
        .start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 250, height: 250 } },
          async (decodedText) => {
            if (isScanHandled.current) return;
            isScanHandled.current = true;
            console.log(decodedText, "decodedText");

            try {
              let bookingId;

              if (
                decodedText.trim().startsWith("{") &&
                decodedText.trim().endsWith("}")
              ) {
                try {
                  const parsed = JSON.parse(decodedText);
                  bookingId = parsed.id;
                  if (!bookingId) throw new Error("Missing booking_id in QR");
                } catch (err) {
                  console.error("Invalid QR JSON format:", err);
                  Swal.fire("Invalid QR code format. Please try again.");
                  stopScanner();
                  return;
                }
              } else {
                const lastSegment = decodedText.substring(
                  decodedText.lastIndexOf("/") + 1,
                );
                bookingId = lastSegment.split("_")[0];
              }

              await handleQRCheck(bookingId);
              stopScanner();
            } catch (err) {
              console.error("QR scan handling error:", err);
              Swal.fire("Error processing QR code.");
              stopScanner();
            }
          },
          (error) => {
            // Optional: console.log("Scan error:", error);
          },
        )
        .then(() => setIsScanning(true))
        .catch((err) => {
          console.error("QR Scanner start error:", err);
          Swal.fire("Unable to start QR scanner. Please check camera access.");
        });
    }

    return () => {
      const stopAndClearScanner = async () => {
        if (qrScannerRef.current) {
          try {
            if (isScanning) {
              await qrScannerRef.current.stop();
            }
            await qrScannerRef.current.clear();
          } catch (err) {
            console.error("Error stopping or clearing QR scanner:", err);
          }
        }
      };
      stopAndClearScanner();
    };
  }, [showScanner]);

  const handleQRCheck = async (bookingId) => {
    try {
      setSelectedBookingId(bookingId);

      // open same popup flow
      setOpenPaymentPopup(true);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to process booking",
      });
    }
  };

  const handleCheck = async (bookingId) => {
    setLoading(true);
    try {
      const response = await venueManagerBookingUrl(bookingId);

      if (response.data.success) {
        localStorage.setItem("venueManagerBookingId", response?.data?.data?.id);

        window.location.href = `/booking-details/${response?.data?.data?.id}`;

        // Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: response.data.message,
        //   confirmButtonText: "Go to Booking Details",
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     window.location.href = `/booking-details/${response?.data?.data?.id}`;
        //   }
        // });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "Something went wrong.",
          showCloseButton: true,
        });
      }
    } catch (error) {
      console.error("Booking check error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
        showCloseButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    {openPaymentPopup && (
  <PaymentPopup
    bookingId={selectedBookingId}
    onClose={() => {
      setOpenPaymentPopup(false);
      setSelectedBookingId(null);
    }}
  />
)}
      {loading ? (
        <div className="text-center my-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <Container className="my-0">
          <Breadcrumb
            breadCrumbPayload={[{ title: "Home", url: "", isActive: true }]}
          />
          <div className="mx-3 pb-3 fs-3 mt-2">Dashboard</div>

          <div
            style={{
              background: "#FFFFFF",
              borderRadius: "16px",
              padding: "20px",
              marginTop: "20px",
            }}
          >
            {/* Header */}
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 mb-3">
              <h5 className="mb-0 fs-3">Home</h5>

              <Button
                style={{
                  background: "#7C3AED",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 16px",
                  fontSize: "16px",
                  width: "100%",
                  maxWidth: "220px",
                }}
                className="w-100 w-sm-auto"
                onClick={() => (window.location.href = "/book-for-others")}
              >
                Book for Others
              </Button>
            </div>

            <Row className="mt-2">
              {/* LEFT CARD */}
              <Col md={6} className="mb-3">
                <Card
                  className="text-center p-4 h-100"
                  onClick={startScanner}
                  style={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #E5E7EB",
                    borderRadius: "14px",
                    cursor: "pointer",
                  }}
                >
                  <div className="d-flex justify-content-center mb-3">
                    <div
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: 12,
                        background: "#EDE9FE",
                        color: "#7C3AED",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 26,
                      }}
                    >
                      <TbLineScan />
                    </div>
                  </div>

                  <h6 className="mb-2 fs-4">Scan QR Code</h6>

                  <p className="text-muted mb-0" style={{ fontSize: 14 }}>
                    Allow users to enter venue by scanning their QR code.
                  </p>
                </Card>
              </Col>

              {/* MODAL — unchanged */}
              <Modal show={showScanner} onHide={stopScanner} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Scan QR Code</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div id="qr-reader" style={{ width: "100%" }} />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={stopScanner}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* RIGHT CARD */}
              <Col md={6} className="mb-3">
                <Card
                  className="p-4 h-100"
                  style={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #E5E7EB",
                    borderRadius: "14px",
                  }}
                >
                  <h6 className=" mb-3 fs-4">Booking ID Number</h6>

                  <Form.Control
                    type="text"
                    placeholder="Enter Booking ID"
                    className="mb-3"
                    value={bookingId}
                    onChange={(e) => setBookingId(e.target.value)}
                    style={{ borderRadius: "8px", height: "42px" }}
                  />
                  <Button
                    className="verify-btn"
                    style={{
                      background: "#7C3AED",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 20px",
                    }}
                    onClick={() => handleCheck(bookingId)}
                  >
                    Verify
                  </Button>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      )}
    </>
  );
}

export default VenueManagerDashboard;
